import React from 'react';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import { lazify } from '../Common/Helper';
import BreadCrumb from '../Common/BreadCrumb';
import AffiliatePage from 'split-chunk-loader?lazy!../StaticPage/Affiliate';
import PhotobookApp from 'split-chunk-loader?lazy!../StaticPage/PhotobookApp';
import GuaranteePage from 'split-chunk-loader?lazy!../StaticPage/Guarantee/Container';
import Business from 'split-chunk-loader?lazy!../BulkDiscount/Page/Business';
import Generic from 'split-chunk-loader?lazy!../BulkDiscount/Page/Generic';
import Nonprofit from 'split-chunk-loader?lazy!../BulkDiscount/Page/Nonprofit';
import Personal from 'split-chunk-loader?lazy!../BulkDiscount/Page/Personal';
import OnlineScrapBook from 'split-chunk-loader?lazy!../StaticPage/OnlineScrapBook';
import UnSubscribeEmail from 'split-chunk-loader?lazy!../StaticPage/UnSubscribeEmail/Container';
import Subscription from 'split-chunk-loader?lazy!../StaticPage/Subscription/Container';
import Summary from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/Summary';
import ContactUs from 'split-chunk-loader?lazy!../StaticPage/ContactUs/Container';
import Disclaimer from 'split-chunk-loader?lazy!../StaticPage/Policy/Disclaimer';
import PrivacyPolicy from 'split-chunk-loader?lazy!../StaticPage/Policy/PrivacyPolicy';
import TermsOfUse from 'split-chunk-loader?lazy!../StaticPage/Policy/TermsOfUse';
import Copyright from 'split-chunk-loader?lazy!../StaticPage/Policy/Copyright';
import ReturnPolicy from 'split-chunk-loader?lazy!../StaticPage/Policy/ReturnPolicy';
import PromotionNotFound from 'split-chunk-loader?lazy!../StaticPage/PromotionNotFound';
import BulkOrderPageResolver from 'split-chunk-loader?lazy!../BulkOrder/Page/BulkOrderPageResolver';

import { Banner, EmailInfoWithMap } from '../StaticPage/ContactUs/ViewComponents';
import Feedback from 'split-chunk-loader?lazy!../StaticPage/Feedback/Container';
import ShippingCalculator from 'split-chunk-loader?lazy!../StaticPage/ShippingCalculator/Container';
import Enterprise from 'split-chunk-loader?lazy!../StaticPage/Enterprise/Container';
import Swag from 'split-chunk-loader?lazy!../StaticPage/Enterprise/Swag';

const PageWrapper = (props) => {
  const { wrapper = 'page-wrapper' } = props;
  return (
    <div>
      {props.banner}
      <BreadCrumb {...props}/>
      <div className='mb-6'/>
      <div className={wrapper}>
        {props.content}
      </div>
      {props.map}
      <div className='mb-6 mb-lg-7 pb-lg-3'></div>
    </div>
  );
};

const bulkOrderMetaDesc = 'Personalisable Photobook Bulk Orders at {storeName} {guaranteeSlogan}';

const Routes = (
  <Route component={PageWrapper}>
    <Route label='Careers' path='career'
      helmet={{
        title: 'Careers',
        metaDescription: 'Be Unique with Us {storeName} {guaranteeSlogan}'
      }}
    />
    <Route label='Affiliate' path='affiliate'
      helmet={{
        title: 'Affiliate',
        metaDescription: 'Join Our Affiliate Program at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(AffiliatePage) }}
    />
    <Route label='Online Scrapbooking' path='online-scrapbooking'
      helmet={{
        title: 'Online Scrapbooking',
        metaDescription: 'Create Fully Personalised Photobooks Online at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(OnlineScrapBook) }}
    />
    <Route label='Unsubscribe Email' path="unsubscribe-email"
      helmet={{
       title: 'Unsubscribe Email',
       metaDescription: 'Unsubscribe from {storeName}'
      }}
      components={{ content: lazify(UnSubscribeEmail) }}
    />
    <Route
      label='Orders'
      path="support/track-order(/)">
      {/* Redirect /support/track-order/ to /account/dashboard/order */}
      <IndexRedirect
        helmet={{
          title: 'Track Order',
          metaDescription: 'We\'ll make sure your book gets to you. {guaranteeSlogan}'
        }}
        to='/account/dashboard/order' />
    </Route>

    <Route
      label='Contact Us'
      helmet={{
        title: 'Contact Our Support Team',
        metaDescription: 'Submit Your Questions to Us at {storeName} {guaranteeSlogan}'
      }}
      path="support/contact(/)"
      components={{
        banner: Banner,
        content: lazify(ContactUs),
        map: EmailInfoWithMap
      }}
    />

    <Route label='Disclaimer' path='disclaimer'
      components={{ content: lazify(Disclaimer) }}
      helmet={{
        title: 'Disclaimer'
      }}
    />
    <Route label='Copy right' path='copy-right'
      components={{ content: lazify(Copyright) }}
      helmet={{
        title: 'Copyright'
      }}
    />
    <Route
      label='Return Policy' path="return-policy">
      <IndexRoute
        label='Return Policy'
        helmet={{
          title: 'Return Policy',
          metaDescription: '100% Satisfaction Guaranteed {guaranteeSlogan}'
        }}
        components={{ content: lazify(ReturnPolicy) }}/>
      <Route
        label='Privacy Policy'
        helmet={{
          title: 'Privacy Policy',
          metaDescription: 'Your Privacy Matters at {storeName} {guaranteeSlogan}'
        }}
        path="privacy-policy" components={{ content: lazify(PrivacyPolicy) }}/>
      <Route
        label='Terms of use'
        helmet={{
          title: 'Terms of Use',
          metaDescription: 'Our Terms of Use at {storeName} {guaranteeSlogan}'
        }}
        path="terms-of-use" components={{ content: lazify(TermsOfUse) }}/>
    </Route>
    <Route label='Photobook App' path='photobookapp'
      helmet={{
        title: 'Photobook App',
        metaDescription: 'Personalisation On The Go at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(PhotobookApp) }}
    />
  </Route>
);

export const checkValidOrder = (nextState, replace) => {
  const {
    location: {
      query: {
        authResult = '',
        paymentMethod = ''
      } = {},
      state: {
        order_id: orderId = null
      } = {}
    } = {}
  } = nextState;

  if (authResult && !['AUTHORISED', 'PENDING'].find(e => e === authResult)) {
    replace('/checkout/shipping');
  } else if (!authResult && (orderId === null)) {
    replace('/');
  }
};

export const WrapperlessRoutes = (
  <Route
    component={ props => (
      <div>
        {props.breadcrumb}
        {props.content}
        <div className='mb-6 mb-lg-7 pb-lg-3'></div>
      </div>
    )}
  >
    <Route label='Order confirmation'
      path='order-confirmation'
      components={{

        content: lazify(Summary)
      }}
      onEnter={checkValidOrder}
    />
    <Route label='Shipping calculator' path='product/shipping-info'
      helmet={{
        title: 'Shipping Information',
        metaDescription: 'Shipping Charges at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(ShippingCalculator) }}
    />
    <Route label='Guarantee' path='guarantee'
      helmet={{
        title: 'Guarantee',
        metaDescription: '100% Satisfaction Guaranteed {guaranteeSlogan}'
      }}
      components={{ content: lazify(GuaranteePage) }}
    />

    <Route label='Feedback' path="support/feedback"
      helmet={{
        title: 'Feedback',
        metaDescription: 'Tell Us Your Experience at {storeName} {guaranteeSlogan}'
      }}
      components={{ breadcrumb: BreadCrumb, content: lazify(Feedback) }}
    />

    <Route label='Bulk Discount' path="bulk-order"
      helmet={{
        title: 'Order in Bulk T-Shirts, Photo Books, Calendars, Canvas, Gifts',
        metaDescription: 'Get more personalisable products for less when you place bulk orders online with us for T-Shirts, Photo books, Canvas, Calendars, Birthday Greeting Cards, Christmas cards, Tumblers, Luggage Tags, and more.'
      }}
      components={{ content: lazify(BulkOrderPageResolver) }}
    />

    <Route label="Bulk Discount"
      helmet={{
        title: 'Bulk Discount',
        metaDescription: 'Personalisable Photobook Bulk Orders at {storeName} {guaranteeSlogan}'
      }}
      path="bulk-order/:product_code"
      components={{ content: lazify(BulkOrderPageResolver) }}
    />

    <Route label='Bulk Discount' path="bulk-discount"
      helmet={{
        title: 'Bulk Discount',
        metaDescription: 'Personalisable Photobook Bulk Orders at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(Generic) }}
    />
    <Route label='Bulk Discount' path="bulk-discount-personal"
      components={{ content: lazify(Personal) }}
      helmet={{
        title: 'Bulk For Personal',
        metaDescription: 'Personalised Bulk Photobooks and Gifts at {storeName} {guaranteeSlogan}'
      }}
    />
    <Route label='Bulk For Business' path="bulk-discount-business"
      helmet={{
        title: 'Bulk For Business',
        metaDescription: bulkOrderMetaDesc
      }}
      components={{ content: lazify(Business) }}
    />
    <Route label='Bulk for Non Profit' path="bulk-discount-nonprofit"
      helmet={{
        title: 'Bulk for Non Profit',
        metaDescription: bulkOrderMetaDesc
      }}
      components={{ content: lazify(Nonprofit) }}
    />
    <Route label='Photobook App' path='photobookapp'
      helmet={{
        title: 'Photobook App',
        metaDescription: 'Personalisation On The Go at {storeName} {guaranteeSlogan}'
      }}
      components={{ content: lazify(PhotobookApp) }}
    />
    <Route label='Promotion Not Found' path='invalid-promotions'
           components={{ content: lazify(PromotionNotFound) }}
           helmet={{
             title: 'Invalid Promotions'
           }}
    />
    <Route label='Photobook Pass' path="pass"
           helmet={{
             title: 'Enjoy Extra Discounts + Unlimited Free Shipping',
             metaDescription: 'Sign-up today for Photobook Pass membership and enjoy Extra Discounts on all products, Free Photobooks, Unlimited Free Shipping on your orders, surprise birthday gift and much more.'
           }}
           components={{ content: lazify(Subscription) }}
    />
    <Route label='Bulk For Business' path="bulk-discount-business"
      helmet={{
        title: 'Bulk For Business',
        metaDescription: bulkOrderMetaDesc
      }}
      components={{ content: lazify(Business) }}
    />
    <Route label='Bulk for Non Profit' path="bulk-discount-nonprofit"
      helmet={{
        title: 'Bulk for Non Profit',
        metaDescription: bulkOrderMetaDesc
      }}
      components={{ content: lazify(Nonprofit) }}
    />
    <Route label='Enterprise' path="enterprise"
      helmet={{
        title: 'Enterprise',
        metaDescription: 'Buy custom business cards, greeting &amp; invitation cards online at {storeName} and personalise your own premium corporate gifts, swag. {guaranteeSlogan}'
      }}
      components={{ content: lazify(Enterprise) }}
    />
    <Route label='Swag' path="enterprise/swag"
      helmet={{
        title: 'SWAG Kit',
        metaDescription: 'Buy custom business cards, greeting &amp; invitation cards online at {storeName} and personalise your own premium corporate gifts, swag. {guaranteeSlogan}'
      }}
      components={{ content: lazify(Swag) }}
    />

    <Route label='Promotion Not Found' path='invalid-promotions'
      components={{ content: lazify(PromotionNotFound) }}
      helmet={{
        title: 'Invalid Promotions'
      }}
    />
  </Route>
);


export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/StaticRoutes.js